import graphql__7d00bf2a13fbf677e051 from "./__generated__/UsersMapRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import UsersMap from "../Maps/UsersMap/UsersMap";

export const USERS_MAP_USERS_COUNT = 20;

const UsersMapRoute = props => {
  const { usersMapSlug } = useParams();

  return (
    <AppQueryRenderer
      key={usersMapSlug}
      query={UsersMapRouteQuery}
      variables={{ usersMapSlug }}
      component={UsersMap}
      additionalProps={props}
    />
  );
};

const UsersMapRouteQuery = graphql__7d00bf2a13fbf677e051;

export default UsersMapRoute;
